import { render } from "./fileInput.vue?vue&type=template&id=20960b3a&ts=true"
import script from "./fileInput.vue?vue&type=script&lang=ts"
export * from "./fileInput.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__